import { ReactNode } from "react"

import { Icon, IconInfoCircle } from "@tabler/icons-react"

import { cn } from "@/lib/utils"

import { Tooltip, type TooltipProps } from "./Tooltip"

export type ExplainerTooltipProps = {
  content: ReactNode
  icon?: Icon
  className?: string
  side?: TooltipProps["side"]
  tooltipClassName?: TooltipProps["className"]
  disableHoverablePopup?: TooltipProps["disableHoverablePopup"]
  /** When set, the trigger becomes a span wrapping these children + the icon. */
  children?: ReactNode
  /** Classes applied to the wrapping span (only when children is set). */
  triggerClassName?: string
  "aria-label"?: string
}

function ExplainerTooltip({
  content,
  icon: IconComponent = IconInfoCircle,
  className,
  side,
  tooltipClassName,
  disableHoverablePopup,
  children,
  triggerClassName,
  "aria-label": ariaLabel = "More information",
}: ExplainerTooltipProps) {
  if (!content) {
    return children !== undefined ? <>{children}</> : null
  }
  const icon = (
    <IconComponent
      aria-label={ariaLabel}
      className={cn("shrink-0 text-muted-foreground", className)}
    />
  )
  return (
    <Tooltip
      content={content}
      side={side}
      className={tooltipClassName}
      disableHoverablePopup={disableHoverablePopup}
    >
      {children !== undefined ? (
        <span className={triggerClassName}>
          {children}
          {icon}
        </span>
      ) : (
        icon
      )}
    </Tooltip>
  )
}

export { ExplainerTooltip }
